export default __webpack_public_path__ + "static/media/rightPersonWrongTime.3359d97f.png";